import React, { Component } from 'react'
import { FacebookProvider, SendToMessenger } from 'react-facebook'

class SendToMessengerComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      FB: null,
      success: props.success,
      isOpen: props.isOpen,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.FB === null && window.FB !== undefined) {
      this.setState({ FB: window.FB })

      window.FB.Event.subscribe('send_to_messenger', async (e) => {
        if (e.event === 'opt_in' && this.state.isOpen) {
          await this.setState({ isOpen: false })
          this.state.success()
          prevProps.toggle()
        }
      })
    }
  }

  render() {
    return (
      <FacebookProvider appId={this.props.messengerAppId}>
        <SendToMessenger
          messengerAppId={this.props.messengerAppId}
          pageId={this.props.messengerPageId}
          dataRef={this.props.candidateId}
        />
      </FacebookProvider>
    )
  }
}

export default SendToMessengerComponent
